import { NormalizeOAS, OASResponse } from 'fets';
import type openapi from '../openapi';
import { ApiClient } from '../fetsClient';
import { assertNever } from '../utils';

type Params = {
  progressTrackingId: number;
  log: string;
  time: number;
};

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<void>;

export const createSetTrackingData = (apiClient: ApiClient): ApiFunction => {
  const setTrackingData = async (params: Params, signal?: AbortSignal): Promise<void> => {
    const response = await apiClient['/api/progress-tracking/{progressTrackingId}'].post({
      params: { progressTrackingId: params.progressTrackingId },
      json: { log: params.log, time: params.time },
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return setTrackingData;
};

type Response = OASResponse<NormalizeOAS<typeof openapi>, '/api/progress-tracking/{progressTrackingId}', 'post'>;

const convertResponse = async (response: Response): Promise<void> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }
};
